export class Attachment {
    RequestID?: number;
    BatchID?: number;
    Name: string;
}

export default Attachment;